import { useMemo } from 'react';
import { isWalletApp, isWalletTbaApp } from '@onramp/utils/isWalletApp';

import { useAppId } from './useAppId';

export function useIsWalletApp() {
  const appId = useAppId();

  return useMemo(() => isWalletApp(appId), [appId]);
}

export function useIsWalletTbaApp() {
  const appId = useAppId();

  return useMemo(() => isWalletTbaApp(appId), [appId]);
}
